import { reactive } from "vue";
import { api } from "~/api";
import { ChangeMailAddress } from "~/api/keiyaku";
import { ValidateCode } from "~/api/keiyaku/commands/ValidateCode";
import { Log } from "~/extensions/utils";
const log = Log.create("MailAddressChange");
class Store {
    mailAddress = "";
    authCode = "";
    authLimit = 0;
    async update(query) {
        this.mailAddress = query.mailAddress;
        let result = await api.keiyaku.changeMail(new ChangeMailAddress(query));
        this.authLimit = result.limit;
    }
    async validate(query) {
        let result = await api.keiyaku.validateCode(new ValidateCode(query.authCode));
        return result;
    }
    clear() {
        this.mailAddress = "";
        this.authCode = "";
        this.authLimit = 0;
    }
}
export let store = reactive(new Store());
